/**
 * OpStart's brand greens, from the 2025 brand guide's green tone scale, as the Tax Profile page uses
 * them on top of the app's dark theme: OpStart Green (Green 90, #064E46) for the thin border around
 * a section or card, and Green 40 (#5FB3A8) for section and card headings, calmer than the guide's
 * Green Neon and still readable on the dark background. Nothing else on the page takes them.
 */
export const BRAND_BORDER_CLASS = 'border border-[#064E46]';

export const BRAND_HEADING_CLASS = 'text-[#5FB3A8]';

/**
 * The pressed tab of the toggle between the Profile and Review views: Green 40 behind OpStart Green
 * text. Important, because daisyUI's tabs-boxed paints its active tab with a more specific rule.
 */
export const BRAND_ACTIVE_TAB_CLASS = '!bg-[#5FB3A8] !text-[#064E46]';
